import React from "react";
import {
  NonRecursivePostCard,
  NonRecursivePostCardConfig,
} from "../../Components/NonRecursivePostCard/NonRecursivePostCard";

import { inlinePlayableTawkPillConfigDemo1 as inlinePlayableTawkPillDemoProps1 } from "../../Components/InlinePlayableTawkPill/InlinePlayableTawkPill";
import { topAnnotationDemoProps1 } from "../../Components/TopAnnotation/TopAnnotation";
import { demoProps1 as interactionBarDemoProps1 } from "../../Components/InteractionBar/InteractionBar";

import { appStoreUrl } from "../../Infrastucture/Constants";

import "./ExpandedPostHeader.css";

export const primaryPostDemoProps2: NonRecursivePostCardConfig = {
  interactionBarConfig: interactionBarDemoProps1,
  primaryContentConfig: inlinePlayableTawkPillDemoProps1,
  topAnnotationBarConfig: topAnnotationDemoProps1,
  analyticsParams: {},
};

export interface FootNoteConfig {
  footnote: string;
}

export const footNoteDemoProps1: FootNoteConfig = {
  footnote:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Egestas sem et aliquam at. #Lorem",
};

export interface ExpandedPostHeaderConfig {
  primaryPost: NonRecursivePostCardConfig;
  primaryPostFootnote: FootNoteConfig | null;
}

export const demoProps1ExpandedPostHeaderConfig: ExpandedPostHeaderConfig = {
  primaryPost: primaryPostDemoProps2,
  primaryPostFootnote: footNoteDemoProps1,
};

function _TakeThisTawkWithYouButton(): JSX.Element {
  return (
    <div>
      <button type="button" className="download-button">
        <p className="download-text">
          Take this tawk with you.{" "}
          <span>
            <a href={appStoreUrl}>Download the Tawkit App</a>
          </span>
        </p>
      </button>
    </div>
  );
}

function _ExpandedPostHeader(props: ExpandedPostHeaderConfig): JSX.Element {
  const { primaryPostFootnote } = props;

  return (
    <div
      className="expanded-header-container"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div className="primary-post">
        <NonRecursivePostCard {...props.primaryPost} />
      </div>

      {primaryPostFootnote && (
        <div className="footnote">
          <p>{primaryPostFootnote.footnote}</p>
        </div>
      )}

      {_TakeThisTawkWithYouButton()}
    </div>
  );
}

export function ExpandedPostHeader(
  props: ExpandedPostHeaderConfig
): JSX.Element {
  return (
    <div>
      <_ExpandedPostHeader {...props} />
    </div>
  );
}
